import PropTypes from 'prop-types';
import React from 'react';

import _ from 'lodash';
import cx from 'classnames';

import { countries as countriesJSON } from 'src/legacy/constants/countries';

import L from 'leaflet';

import { MapContainer, TileLayer, CircleMarker, Tooltip as ReactLeafletPopup } from 'react-leaflet';

import styles from './styles.module.scss';

import { localizedStrings } from 'src/localization/index.jsx';
import EventService from 'src/services/event.service';

export default class ChatUsersMapView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      legend: 'all',
      locations: []
    };
    this.localizedEngage = localizedStrings.pages.engage;

    // Create a reference to the map instance
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    this.processLocations(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.locations, nextProps.locations)) {
      this.processLocations(nextProps);
    }
  }

  processLocations(props) {
    const locations = (props.locations || []).map((location, index) => {
      const countryCode = location.countryCode;

      const country = countriesJSON.find(e => e.country_code === countryCode);

      if (!country) {
        return null;
      }

      const latlng = country.latlng;

      let status = 'lastWeek';
      if (location.online > 0) {
        status = 'live';
      } else if (location.last24Hours) {
        status = 'last24Hours';
      }

      let total = location.total;
      switch (this.state.legend) {
        case 'live':
          total = location.online;
          break;
        case 'last24Hours':
          total = location.last24Hours;
          break;
        case 'lastWeek':
          total = location.lastWeek;
          break;
        default:
          total = location.total;
      }

      return {
        name: country.name,
        latlng: latlng,
        status: status,
        total: total
      };
    }).filter(location => _.get(location, 'total', 0) > 0);

    this.setState({ locations }, () => {
      const map = this.mapRef.current; // Access map instance
      if (map) {
        const bounds = this.calculateBounds(locations);
        if (_.size(bounds) > 0) {
          map.fitBounds(bounds); // Use `fitBounds` on the map instance
        }
      }
    });
  }

  handleLegendsClick(legend) {
    const legendName = EventService.getMapFilterName(legend);
    // this.props.trackAdoptionMetricsForMapFilterAppliedEvent(legendName);
    this.setState({ legend }, () => {
      this.processLocations(this.props);
    });
  }

  calculateBounds(locations) {
    const markers = locations.map(location => L.latLng(location.latlng));

    if (_.size(markers) === 0) {
      return L.latLngBounds([[41.8719, 12.5674]]);
    }

    return L.latLngBounds(markers);
  }

  render() {
    return (
      <div className={styles.map}>

        <div className={styles.legends}>
          <p className={cx({ [styles.active]: this.state.legend === 'all' })}
            onClick={() => this.handleLegendsClick('all')}>
            {this.localizedEngage.actions.all}
          </p>
          <p className={cx({ [styles.active]: this.state.legend === 'live' })}
            onClick={() => this.handleLegendsClick('live')}>
            {this.localizedEngage.actions.live}
          </p>
          <p className={cx({ [styles.active]: this.state.legend === 'last24Hours' })}
            onClick={() => this.handleLegendsClick('last24Hours')}>
            {this.localizedEngage.actions.hours}
          </p>
          <p className={cx({ [styles.active]: this.state.legend === 'lastWeek' })}
            onClick={() => this.handleLegendsClick('lastWeek')}>
            {this.localizedEngage.actions.days}
          </p>
        </div>

        <MapContainer
          ref={this.mapRef}
          whenCreated={(map) => this.mapRef.current = map} // Store map instance in ref
          maxZoom={this.state.locations.length > 0 ? 5 : 1.25}
          style={{ height: "300px" }}
        >
          <TileLayer
            opacity={1}
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url='https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}'
          />
          {(this.state.locations || []).map((location, index) => (
            <CircleMarker
              key={index}
              fill={false}
              className={cx(styles.marker, styles[location.status])}
              radius="5"
              center={location.latlng}
            >
              <ReactLeafletPopup className={styles.popupMarker} direction="top">
                <div className={styles.content}>
                  <div className={styles.label}>{location.name}</div>
                  <div className={styles.value}>{location.total}</div>
                </div>
              </ReactLeafletPopup>
            </CircleMarker>
          ))}
        </MapContainer>

      </div>
    );
  }
}
